// @ts-check
// O que resolve a pendência de um anfitrião (3.5.0, contrato 10 de agendamento, seção 7.5), compartilhado pelo editor
// da página e pelo cartão "Quem pode receber reservas" de Agendamentos: convite a outro membro (aviso e e-mail), aceite
// pela própria conta quando ela já cria eventos, ou a ida ao Google pela permissão de criar eventos já com o aceite
// gravado (bookingHost), voltando para a tela de onde saiu.
import { inviteBookingHost, setBookingHostConsent } from '../../data/booking-pages.js';
import { startAccountConnection } from '../../data/calendar.js';
import { hostGoogleAccount } from '../../lib/booking-pages.js';
import { navigate } from '../../app/router.js';

/** @typedef {import('../../data/booking-pages.js').BookingHost} BookingHost */

/**
 * @param {BookingHost} host @param {'ACCEPT' | 'CONNECT' | 'INVITE'} action
 * @param {{ bookingPageId?: string | null, returnTo: 'BOOKING_PAGES' | 'BOOKING_PAGE', returnToId?: string, chosenAccountId?: string | null }} options
 * @returns {Promise<{ outcome: 'INVITED' | 'ALREADY_INVITED', memberName: string } | { outcome: 'READY' } | { outcome: 'REDIRECTED' }>}
 */
export async function runHostAction(host, action, options) {
  if (action === 'INVITE') {
    const invitation = await inviteBookingHost({ workspaceMemberId: host.workspaceMemberId, bookingPageId: options.bookingPageId ?? null });
    return { outcome: invitation.wasCreated ? 'INVITED' : 'ALREADY_INVITED', memberName: invitation.memberName };
  }
  const account = action === 'ACCEPT' ? hostGoogleAccount(host, options.chosenAccountId ?? null) : null;
  // a conta já cria eventos: só falta o aceite, que fica gravado sem sair da tela
  if (account && account.reason === 'HOST_CONSENT_REQUIRED') {
    await setBookingHostConsent(account.connectedAccountId, true);
    return { outcome: 'READY' };
  }
  const authorizationUrl = await startAccountConnection('google', {
    calendarEvents: true, bookingHost: true, returnTo: options.returnTo,
    ...(options.returnToId ? { returnToId: options.returnToId } : {}),
    ...(account ? { connectedAccountId: account.connectedAccountId } : {}),
  });
  // o modo demonstração devolve um caminho local; o real, a tela de consentimento do Google
  if (authorizationUrl.startsWith('/')) navigate(authorizationUrl);
  else window.location.assign(authorizationUrl);
  return { outcome: 'REDIRECTED' };
}
